import { DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutBillingRegisterReport extends Layout {
    excludabletextboxC: ExcludableTextbox;
    sourceBillingRegister: DataSource;
    switchGroupByCust: Switch;
    textboxCurrency: Textbox;
    textboxD: Textbox;
    textboxDateRange: Textbox;
    textboxReportType: Textbox;
}
